import logo from "../assets/logo.png";

export function Logo(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return <img src={logo} alt="Logo" width={1698} height={310} {...props} />;
}

